import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'

// build projects
export const projectsData = [
    {
        id: 1,
        projectName: '',
        projectDesc: '',
        tags: ['React', 'CSS', 'Material Ui'],
        code: '',
        demo: '',
        image: one
    },
    {
        id: 2,
        projectName: '',
        projectDesc: '',
        tags: ['Django', 'Tailwind CSS'],
        code: '',
        demo: '',
        image: two
    },
    {
        id: 3,
        projectName: '',
        projectDesc: '',
        tags: ['Django', 'CSS', 'Material Ui'],
        code: '',
        demo: '',
        image: three
    },
    {
        id: 4,
        projectName: '',
        projectDesc: '',
        tags: ['Flutter', 'Firebase'],
        code: '',
        demo: '',
        image: four
    },
    {
        id: 5,
        projectName: '',
        projectDesc: '',
        tags: ['React Native', 'Firebase'],
        code: '',
        demo: '',
        image: five
    },
    {
        id: 6,
        projectName: '',
        projectDesc: '',
        tags: ['Flutter'],
        code: '',
        demo: '',
        image: six
    },
    {
        id: 7,
        projectName: '',
        projectDesc: '',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: '',
        demo: '',
        image: seven
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: '',
        tags: ['Flutter', 'React'],
        code: '',
        demo: '',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/